<template>
  <div class="container py-3">
    <h5>EBPP 테스트</h5>
    <p>백엔드로 전화번호와 메시지만 전송하여 EBPP 주문을 생성합니다.</p>
    <div class="mb-2">
      <label class="form-label">전화번호 (phoneNumber)</label>
      <input class="form-control" v-model="phone" placeholder="예: 01012341234" />
    </div>
    <div class="mb-2">
      <label class="form-label">메시지 (msg)</label>
      <input class="form-control" v-model="message" placeholder="보낼 메시지를 입력하세요" />
    </div>
    <div class="mb-2">
      <label class="form-label">phoneNumber와 msg만 백엔드로 전송됩니다.</label>
    </div>
    <button class="btn btn-primary" @click="sendTest" :disabled="sending">테스트 전송</button>
    <div class="mt-3">
      <pre v-if="result">{{ result }}</pre>
      <div v-if="outgoingRequest" class="mt-2">
        <h6>Outgoing Request</h6>
        <pre>{{ JSON.stringify(outgoingRequest, null, 2) }}</pre>
      </div>
      <div v-if="outgoingResponse" class="mt-2">
        <h6>Outgoing Response</h6>
        <pre>{{ JSON.stringify(outgoingResponse, null, 2) }}</pre>
      </div>
      <div v-if="error" class="text-danger">{{ error }}</div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'EbppTest',
  data() {
    return {
      sending: false,
      result: null,
      error: null,
      phone: '01064203694',
      message: '정기권 결제 URL@ENhttps://pmpark.efmc.or.kr/',
      outgoingRequest: null,
      outgoingResponse: null
    };
  },
  methods: {
    // No frontend encryption: send plaintext cpNo to backend for encryption

    async sendTest() {
      this.sending = true;
      this.result = null;
      this.error = null;

      const apiBase = process.env.VUE_APP_API_BASE || '';
      const url = `${apiBase}/api/ebpp/send`;

      const requestBody = {
        phoneNumber: this.phone.trim(),
        msg: this.message.trim(),
        areaSeq: 1
      };

      try {
        const res = await axios.post(url, requestBody);
        this.result = JSON.stringify(res.data, null, 2);
        // show outgoing logs if provided
        this.outgoingRequest = res.data.outgoingRequest || null;
        this.outgoingResponse = res.data.outgoingResponse || null;
      } catch (e) {
        console.error(e);
        const resp = e.response?.data;
        if (resp) {
          this.result = JSON.stringify(resp, null, 2);
          this.outgoingRequest = resp.outgoingRequest || null;
          this.outgoingResponse = resp.outgoingResponse || null;
          this.error = resp.message || resp.error || (resp.body && resp.body.message) || 'Request failed';
        } else {
          this.error = e.message || 'Request failed';
        }
      } finally {
        this.sending = false;
      }
    }
  }
};
</script>

<style scoped>
pre { background:#f8f9fa; padding:10px; }
</style>

